export default class SocketState {
  listOfOccurrences: number;

  constructor(listOfOccurrences: number = 0) {
    this.listOfOccurrences = listOfOccurrences;
  }
}
